import React from "react";
import { supabase } from "../utils/supabaseClient"; // Ensure this path is correct

export default function Upgrade() {
  // 💡 Stripe Upgrade Logic (no changes needed here)
  const handleUpgrade = async (priceId) => {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();

      if (!session) {
        alert("🔒 Please log in to upgrade your plan.");
        window.location.href = "/login";
        return;
      }

      const access_token = session.access_token;

      const res = await fetch(`${"https://vintariai-backend-1.onrender.com"}/api/create-checkout-session`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify({ price_id: priceId }),
      });

      const data = await res.json();

      if (data.url) {
        window.location.href = data.url;
      } else {
        alert("Something went wrong with checkout.");
      }
    } catch (err) {
      console.error("❌ Checkout error:", err);
      alert("Unable to start checkout.");
    }
  };

return (
  <div className="min-h-screen bg-black text-white flex flex-col items-center px-6 py-12 overflow-y-auto">
    <div className="w-full max-w-5xl text-center">
      
      {/* --- Header Section --- */}
      <div className="relative inline-block mb-4">
        <h1 className="relative text-4xl md:text-5xl font-bold px-4 py-2">
          Decisive Leaders Don’t Wait. Secure Your Edge Today.
        </h1>
      </div>
      <p className="text-white/80 mb-12 max-w-4xl mx-auto">
        The market rewards speed and clarity. VintariAI gives you both — instantly.
        Already applied in real-world innovation work and used as a strategy tool in the book 
        <span className="font-semibold"> “But What If I’m Not Elon Musk?!” (Berkeley Innovation Forum, 2025)</span>.
      </p>


      {/* --- Pricing Grid Section --- */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-sm mb-12">
        {/* Free Plan / Explore Mode */}
        <div className="bg-gray-900 rounded-xl p-6 border border-white/20 flex flex-col">
          <h2 className="font-semibold mb-1 text-white text-lg">Free</h2>
          <p className="text-xs text-white/60 mb-4">Enough to see the potential, not enough to win.</p>
          <div className="my-6">
            <span className="text-4xl font-bold">$0</span>
          </div>
          <ul className="list-disc list-inside text-white/70 space-y-2 text-left flex-grow">
            <li>Daily access to strategic insights</li>
            <li>Vintari Strategist model</li>
            <li>A taste of core frameworks</li>
          </ul>
        </div>

        {/* Professional / Momentum Mode */}
        <div className="relative group">
          <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-purple-600 text-white text-xs font-bold px-3 py-1 rounded-full z-10">
            MOST POPULAR
          </div>
          <div className="absolute -inset-0.5 bg-purple-600 rounded-xl blur-md opacity-75 group-hover:opacity-100 transition duration-300"></div>
          <div className="relative bg-gray-900 rounded-xl p-6 border border-purple-400/50 h-full flex flex-col">
            <h2 className="font-semibold mb-1 text-white text-lg">Professional</h2>
            <p className="text-xs text-white/60 mb-4">The smart leader’s entry point.</p>

            <div className="my-5">
              <span className="text-4xl font-bold">$14.99</span>
              <span className="text-white/60">/month</span>
            </div>

            <ul className="list-disc pl-4 text-white space-y-2 text-left flex-grow">
              <li>End-to-end strategic workflow, built for momentum</li>
              <li>Unlock core strategy libraries for proven results</li>
              <li>Unlock Adaptive Strategist mode</li>
              <li>Save & search chat history</li>
              <li>Upload files for analysis (PDF, TXT, etc.)</li>
              <li>Export strategies (PDF, TXT, MD)</li>
              <li>Confidential by design, your strategies stay yours</li>
            </ul>

            <button
              onClick={() => handleUpgrade("price_1S6Oz8EmHwofE2AIX4UNvkpB")} // TODO: replace with your Stripe price id
              className="mt-4 w-full bg-purple-600 text-white hover:bg-purple-500 transition py-3 px-4 rounded-lg font-semibold shadow text-center text-base"
            >
              Upgrade Now
            </button>
          </div>
        </div>

        {/* Elite Strategist / Boardroom Mode */}
        <div className="relative group">
          <div className="absolute -inset-0.5 bg-amber-400 rounded-xl blur-md opacity-75 group-hover:opacity-100 transition duration-300"></div>
          <div className="relative bg-gray-900 rounded-xl p-6 border border-amber-400/50 h-full flex flex-col">
            <h2 className="font-semibold mb-1 text-amber-400 text-lg">Elite Strategist</h2>
            <p className="text-xs text-white/60 mb-1">The only choice when failure isn’t an option.</p>

            <div className="my-5">
              <span className="text-4xl font-bold text-amber-400">$59.99</span>
              <span className="text-white/60">/month</span>
            </div>

            <ul className="list-disc pl-4 text-white space-y-2 text-left flex-grow">
              <li>Everything in Professional, plus:</li>
              <li>
                <span className="font-semibold text-amber-400">Unlock Risk Horizon Scan and Innovation Catalyst</span>
              </li>
              <li>
                <span className="font-semibold text-amber-400">Decision Overlays™</span>
                — convert any response into <em>board memos, tradeoff matrices, or scenario playbooks</em> for decision-ready outputs.
              </li>
              <li>Peak capacity analysis for complex, high-stakes scenarios</li>
              <li>Priority support with accelerated turnaround on requests</li>
            </ul>

            <p className="mt-4 text-xs text-white/60">
              ⏳ Enrollment is limited. Only a select number of Elite seats open each quarter to ensure focus and high-quality support.
            </p>

            <button
              onClick={() => handleUpgrade("price_1RtF7LEmHwofE2AIHPgc1n5o")} // TODO: replace with your Stripe price id
              className="mt-4 w-full bg-amber-500 text-black hover:bg-amber-400 transition py-3 px-4 rounded-lg font-semibold shadow text-center text-base"
            >
              Go Elite
            </button>
          </div>
        </div>
      </div>
{/* Corporate / Business Plan */}
<div className="relative group">
  <div className="absolute -inset-0.5 bg-blue-500 rounded-xl blur-md opacity-75 group-hover:opacity-100 transition duration-300"></div>
  <div className="relative bg-gray-900 rounded-xl p-6 border border-blue-400/50 h-full flex flex-col text-center">
    <h2 className="font-semibold mb-1 text-blue-400 text-lg">Corporate / Business</h2>
    <p className="text-xs text-white/60 mb-3">
      Built for teams that need strategy at scale.
    </p>

    <div className="my-5">
      <span className="text-3xl font-bold text-blue-400">Custom</span>
      <span className="text-white/60"> / per seat</span>
    </div>
  <ul className="list-disc list-outside marker:text-blue-400 text-white space-y-2 text-left mx-auto max-w-md pl-6 leading-relaxed flex-grow">
    <li>All Elite features plus multi-seat access</li>
    <li>Centralized billing & role management</li>
    <li>Enterprise-grade compliance & controls</li>
    <li>Dedicated account manager & onboarding</li>
  </ul>

    <a
      href="https://docs.google.com/forms/d/e/1FAIpQLScYdVuvpyoKV3q04QaVoedAXePxGFOVeTP5uUC0EOFIpyNkYA/viewform?usp=header"
      target="_blank"
      rel="noopener noreferrer"
      className="mt-6 w-full bg-blue-500 text-white hover:bg-blue-400 transition py-3 px-4 rounded-lg font-semibold shadow text-center text-base"
    >
      Contact Sales
    </a>
  </div>
</div>

      <div className="mt-24">
        <a href="/" className="text-white/60 hover:text-white underline text-sm">
          ← Back to Home
        </a>
      </div>
    </div>
  </div>
);

}